import React from 'react';
import PropTypes from 'prop-types';
import { Box } from './Boneyard';
import styled from 'styled-components';

const propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  gapWidth: PropTypes.number,
  radius: PropTypes.number,
  step: PropTypes.number,
  steps: PropTypes.number,
  strokeWidth: PropTypes.number,
  children: PropTypes.node,
};

const defaultProps = {
  backgroundColor: 'grey',
  color: 'black',
  gapWidth: 2,
  radius: 50,
  step: 0,
  steps: 1,
  strokeWidth: 4,
};

const RadialProgress = ({
  backgroundColor,
  color,
  gapWidth,
  radius,
  step,
  steps,
  strokeWidth,
  children,
}) => {
  const diameter = radius * 2;
  const normalizedRadius = radius - strokeWidth * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset =
    circumference - (Math.min(step, steps) / steps) * circumference;

  const svgProps = {
    width: diameter,
    height: diameter,
    style: {
      position: 'absolute',
      transform: 'rotate(-90deg)',
    },
  };

  const circleProps = {
    fill: 'transparent',
    r: normalizedRadius,
    cx: radius,
    cy: radius,
  };

  const Progress = () => (
    <svg {...svgProps}>
      <circle
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={strokeDashoffset}
        {...circleProps}
      />
    </svg>
  );

  const Segments = () => (
    <svg {...svgProps}>
      <circle
        stroke="white"
        strokeDasharray={`${gapWidth} ${circumference / steps - gapWidth}`}
        strokeDashoffset={gapWidth / 2}
        strokeWidth={strokeWidth + 1}
        {...circleProps}
      />
    </svg>
  );

  const Background = () => (
    <svg {...svgProps}>
      <circle
        stroke={backgroundColor}
        strokeWidth={strokeWidth}
        {...circleProps}
      />
    </svg>
  );

  const NoShrinkWrapper = styled(Box)`
    flex-shrink: 0;
  `;

  return (
    <NoShrinkWrapper position="relative" w={diameter} h={diameter}>
      {children && (
        <Box
          d="flex"
          position="absolute"
          w="100%"
          h="100%"
          alignItems="center"
          justifyContent="center"
        >
          {children}
        </Box>
      )}
      <Background />
      <Progress />
      <Segments />
    </NoShrinkWrapper>
  );
};

RadialProgress.propTypes = propTypes;
RadialProgress.defaultProps = defaultProps;

export default RadialProgress;
